import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import customApp from './src/customApp';
import { addApp, addExternalRoute } from './src/utils';


import { authnApp } from '@openedx/frontend-app-authn';



import { learnerDashboardApp } from '@openedx/frontend-app-learner-dashboard';



import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';



import { notificationsApp } from '@openedx/frontend-app-notifications';







import '@openedx/frontend-base/shell/style';
import '@edx/brand/core.min.css';
import '@edx/brand/light.min.css';

const siteConfig: SiteConfig = {
  siteId: 'tutor-site',
  siteName: "My Open edX",
  baseUrl: 'https://apps.ulmo-to-verawood.grove-ulmo-to-verawood-aws.opencraft.hosting',
  cmsBaseUrl: 'https://studio.ulmo-to-verawood.grove-ulmo-to-verawood-aws.opencraft.hosting',
  lmsBaseUrl: 'https://ulmo-to-verawood.grove-ulmo-to-verawood-aws.opencraft.hosting',
  loginUrl: 'https://ulmo-to-verawood.grove-ulmo-to-verawood-aws.opencraft.hosting/login',
  logoutUrl: 'https://ulmo-to-verawood.grove-ulmo-to-verawood-aws.opencraft.hosting/logout',

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  externalRoutes: [],

  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};


addApp(siteConfig, authnApp);



addApp(siteConfig, learnerDashboardApp);



addApp(siteConfig, instructorDashboardApp);



addApp(siteConfig, notificationsApp);





export default siteConfig;